import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reportBuilderApi } from '../api/reportBuilderApi';
import type { ReportDefinitionRequest } from '../types/reportBuilder';

/**
 * PUT /api/eraf/report-builder/reports/{id} — 리포트 정의 수정 (REPORT_CREATE + owner)
 */
export function useUpdateReportDef() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: ReportDefinitionRequest }) =>
      reportBuilderApi.update(id, body),
    onSuccess: (_data, { id }) => {
      void queryClient.invalidateQueries({ queryKey: ['report-builder', 'list'] });
      void queryClient.invalidateQueries({ queryKey: ['report-builder', 'detail', id] });
    },
  });
}
